import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fadeInAnimation } from '../_animations/fade-in.animation';
import { SessionService } from '../session/session.service';
import { PortalMode } from '../enum/portalmode.enum';

@Component({
    selector: 'app-more-info',
    templateUrl: './more-info.component.html',
    animations: [fadeInAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoreInfoComponent {
  public readonly textKey: string;
  public readonly borgenarTextKey: string;

  public get isBorgenarMode(): boolean {
    return this.sessionService.getPortalMode() === PortalMode.Borgenar;
  }

  constructor(protected sessionService: SessionService, protected route: ActivatedRoute) {
    this.textKey = route.snapshot.data['textKey'];
    this.borgenarTextKey = route.snapshot.data['borgenarTextKey'];
  }
}
